module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/user-subscriptions/user-subscriptions.component.sass
// module id = ./src/app/payment/user-subscriptions/user-subscriptions.component.sass
// module chunks = main